/* Cloudwear: zachowania globalne.
   1) Transparentny header nad hero (GSQ) — tylko gdy pierwszą sekcją strony jest .cw-hero.
   2) Klasa cw-scrolled po przescrollowaniu — header wraca do bieli. */
(function () {
  var headerSection = document.querySelector('.section-header');
  var main = document.getElementById('MainContent');
  if (!headerSection || !main) return;

  /* ── i18n (EN etap 1): stringi sklejane w JS idą z window.cwStrings
     (theme.liquid → locales/*.json), fallback PL. cwUrl dokleja prefiks
     języka (routes.root_url, np. /en) do ręcznie budowanych ścieżek —
     bez niego klientka EN wypadałaby na polskie wersje stron. */
  var cwStr = window.cwStrings || {};
  var cwRootUrl = ((window.routes && window.routes.root_url) || '/').replace(/\/$/, '');
  var cwUrl = function (path) { return cwRootUrl + path; };
  /* ceny sklejane w JS: waluta sesji (waluty lokalne Shopify Payments),
     nie sztywne „zł" — Intl formatuje wg języka strony */
  var cwMoney = function (amount, whole) {
    var n = typeof amount === 'number' ? amount : parseFloat(String(amount).replace(',', '.'));
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat(cwStr.locale || 'pl', {
        style: 'currency',
        currency: cwStr.currency || 'PLN',
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2,
      }).format(n);
    } catch (e) {
      return n.toFixed(whole ? 0 : 2).replace('.', ',') + ' ' + (cwStr.currencySymbol || 'zł');
    }
  };
  var cwReviewsCount = function (n) {
    var few = n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14);
    var tpl = n === 1 ? (cwStr.reviewsOne || '[n] opinia')
      : few ? (cwStr.reviewsFew || '[n] opinie') : (cwStr.reviewsMany || '[n] opinii');
    return tpl.replace('[n]', n);
  };

  /* Selektor PLN/PL (16.09): select języka siedzi w formie localization
     (obok country_code) — zmiana od razu submituje formę; Shopify
     przekierowuje na odpowiednik strony w nowym języku i zapamiętuje wybór */
  document.addEventListener('change', function (event) {
    var sel = event.target;
    if (!sel || !sel.matches || !sel.matches('[data-cw-lang-select]')) return;
    var form = sel.closest('form');
    if (form) form.submit();
  });
  /* pancerne zamykanie panelu (zgłoszenie Michała ×2): pointerdown w fazie
     CAPTURE — odpala się przed każdym innym skryptem, nic go nie połknie;
     dodatkowo scroll strony zamyka (standard dropdownów; tylko desktop —
     mobilny panel jest pełnoekranowy i scrolluje własną listę) */
  var cwLocCloseAll = function (event) {
    document.querySelectorAll('localization-form').forEach(function (lf) {
      var panel = lf.querySelector('.disclosure__list-wrapper');
      if (!panel || panel.hasAttribute('hidden')) return;
      if (event && lf.contains(event.target)) return;
      if (typeof lf.hidePanel === 'function') lf.hidePanel();
    });
  };
  document.addEventListener('pointerdown', cwLocCloseAll, true);
  /* desktop: panel znika też po ODJECHANIU myszą (350 ms tolerancji) —
     naturalne oczekiwanie Michała („nie chce zniknąć" ×3); hover:hover
     = nie dotyczy mobilnego pełnoekranowego panelu */
  if (window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('localization-form').forEach(function (lf) {
      var cwLocLeaveT = null;
      lf.addEventListener('pointerenter', function () {
        if (cwLocLeaveT) { window.clearTimeout(cwLocLeaveT); cwLocLeaveT = null; }
      });
      lf.addEventListener('pointerleave', function () {
        var panel = lf.querySelector('.disclosure__list-wrapper');
        if (!panel || panel.hasAttribute('hidden')) return;
        cwLocLeaveT = window.setTimeout(function () {
          if (typeof lf.hidePanel === 'function') lf.hidePanel();
        }, 350);
      });
    });
  }
  window.addEventListener('scroll', function () {
    if (window.matchMedia('(min-width: 750px)').matches) cwLocCloseAll(null);
  }, { passive: true });

  var firstSection = main.querySelector('.shopify-section');
  var hero = firstSection ? firstSection.querySelector('.cw-hero:not(.cw-hero--placeholder)') : null;
  /* PDP mobile: header transparentny nad galerią (GSQ) — CSS ogranicza do <750px */
  var pdpMedia = main.querySelector('.product--stacked .product__media-wrapper');

  if (hero || pdpMedia) {
    document.body.classList.add(hero ? 'cw-overlay-header' : 'cw-pdp-overlay');
  }
  /* 22.09: --cw-header-h ustawiane ZAWSZE (nie tylko overlay) — sticky
     belka filtrów kolekcji przykleja się POD headerem (top: var(...)),
     odkąd header jest transparent i "always" */
  var setHeaderHeight = function () {
    document.body.style.setProperty('--cw-header-h', headerSection.offsetHeight + 'px');
  };
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);

  /* header on-scroll-up (28.08): Dawn pokazuje przy każdym drgnięciu w górę
     — trzymamy go schowanego, aż użytkownik przescrolluje w górę ~160px */
  var cwLastY = window.scrollY;
  var cwUpAcc = 0;
  var onScroll = function () {
    document.body.classList.toggle('cw-scrolled', window.scrollY > 24);
    var y = window.scrollY;
    var dy = y - cwLastY;
    cwLastY = y;
    if (dy < 0) cwUpAcc += -dy;
    else if (dy > 0) cwUpAcc = 0;
    /* (22.09: cw-hold-hidden wycofane — sticky_header_type 'always') */
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  /* Fallback dla środowisk bez zdarzeń scroll (podglądy/webview) */
  window.setInterval(onScroll, 400);
  onScroll();

  /* Klasy na body: otwarta wyszukiwarka / otwarte menu (sterują tłem headera i paskiem).
     Uwaga: Dawn renderuje search w headerze wielokrotnie — nasłuchujemy na WSZYSTKICH. */
  var syncSearchOpen = function () {
    var isOpen = !!document.querySelector('.header__search details[open]');
    document.body.classList.toggle('cw-search-open', isOpen);
    /* GSQ: search otwiera się BEZ klawiatury — zdejmujemy focus, który wymusza Dawn */
    if (isOpen) {
      var blurSearch = function () {
        var ae = document.activeElement;
        if (ae && ae.matches && ae.matches('.search-modal input[type="search"]')) ae.blur();
      };
      window.setTimeout(blurSearch, 50);
      window.setTimeout(blurSearch, 250);
    }
  };
  document.querySelectorAll('.header__search details').forEach(function (d) {
    d.addEventListener('toggle', syncSearchOpen);
  });
  var menuDetails = document.getElementById('Details-menu-drawer-container');
  if (menuDetails) {
    /* Drawer menu jest FIXED (CLAUDE.md §11) — jego górna krawędź = dolna krawędź
       headera w viewportcie (mierzona w chwili otwarcia; sticky header = stała wartość) */
    var setMenuTop = function () {
      var hw = document.querySelector('.header-wrapper');
      if (!hw) return;
      // GSQ: pasek ogłoszeń zostaje widoczny, jeśli jest w viewportcie w chwili
      // otwarcia (scroll 0 → header fixed pod paskiem, menu pod headerem);
      // po przescrollowaniu pasek już odjechał → wszystko od samej góry
      var ann = document.querySelector('.announcement-bar-section, .utility-bar');
      var annBottom = ann ? Math.max(0, Math.round(ann.getBoundingClientRect().bottom)) : 0;
      document.body.style.setProperty('--cw-menu-hdr-top', annBottom + 'px');
      document.body.style.setProperty('--cw-header-total-h', annBottom + Math.round(hw.offsetHeight) + 'px');
    };
    menuDetails.addEventListener('toggle', function () {
      if (menuDetails.open) setMenuTop();
      document.body.classList.toggle('cw-menu-open', menuDetails.open);
      /* pełny lock scrolla pod otwartym menu (22.08) — PO setMenuTop,
         żeby pomiar paska ogłoszeń widział prawdziwą geometrię */
      if (menuDetails.open) cwLockScroll();
      else cwUnlockScroll();
    });
    window.addEventListener('resize', function () {
      if (menuDetails.open) setMenuTop();
    });
  }

  /* ── Wyszukiwarka (GSQ): stan domyślny — Ostatnio wyświetlone + Produkty ──
     Obsługujemy WSZYSTKIE instancje searcha (Dawn renderuje go w headerze 2×). */
  var searchDefaults = document.querySelectorAll('[data-cw-search-default]');
  if (searchDefaults.length) {
    var cwPopularHtml = null;

    var tile = function (url, image, title, price) {
      return '<a class="cw-search-tile" href="' + url + '">'
        + (image ? '<img src="' + image + '" alt="" loading="lazy">' : '<span class="cw-search-tile__ph"></span>')
        + '<span class="cw-search-tile__title">' + title + '</span>'
        + '<span class="cw-search-tile__price">' + price + '</span></a>';
    };

    var renderRecent = function () {
      var recent = [];
      try { recent = JSON.parse(localStorage.getItem('cw:recent') || '[]'); } catch (e) { recent = []; }
      recent = recent.slice(0, 4);
      var html = recent.map(function (r) { return tile(r.u, r.i, r.t, r.p); }).join('');
      searchDefaults.forEach(function (box) {
        box.querySelector('[data-cw-recent-grid]').innerHTML = html;
        box.querySelector('[data-cw-recent-head]').hidden = recent.length === 0;
      });
    };

    var applyPopular = function () {
      if (!cwPopularHtml) return;
      searchDefaults.forEach(function (box) {
        box.querySelector('[data-cw-popular-grid]').innerHTML = cwPopularHtml;
        box.querySelector('[data-cw-popular-head]').hidden = false;
      });
    };

    var loadPopular = function () {
      if (cwPopularHtml !== null) { applyPopular(); return; }
      cwPopularHtml = '';
      fetch(cwUrl('/collections/nowosci/products.json?limit=4'))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.products || !data.products.length) return;
          cwPopularHtml = data.products.map(function (p) {
            var img = p.images && p.images[0] ? p.images[0].src + '&width=600' : '';
            if (img && img.indexOf('?') === -1) img = img.replace('&width=600', '?width=600');
            var price = p.variants && p.variants[0] ? cwMoney(p.variants[0].price) : '';
            return tile(cwUrl('/products/' + p.handle), img, p.title, price);
          }).join('');
          applyPopular();
        })
        .catch(function () {});
    };

    var syncDefaultVisibility = function () {
      searchDefaults.forEach(function (box) {
        var content = box.closest('.search-modal__content');
        var input = content ? content.querySelector('input[type="search"]') : null;
        box.hidden = !!(input && input.value.trim() !== '');
      });
    };

    document.addEventListener('click', function (event) {
      if (event.target.closest('.header__search summary')) {
        renderRecent();
        loadPopular();
        window.setTimeout(syncDefaultVisibility, 50);
      }
      if (event.target.closest('[data-cw-recent-clear]')) {
        try { localStorage.removeItem('cw:recent'); } catch (e) {}
        renderRecent();
      }
    });
  }

  /* ══ SEARCH DRAWER (28.08) — zamiast Dawnowego modalu ══
     Lupka otwiera drawer z prawej (jak koszyk); stan pusty = samo pole;
     wyniki dopiero po wpisaniu (suggest API: frazy + produkty). */
  (function () {
    var root = document.getElementById('CwSearch');
    if (!root) return;
    var input = root.querySelector('[data-cw-search-input]');
    var body = root.querySelector('[data-cw-search-body]');
    var qWrap = root.querySelector('[data-cw-search-queries]');
    var qList = root.querySelector('[data-cw-search-queries-list]');
    var pWrap = root.querySelector('[data-cw-search-products]');
    var pList = root.querySelector('[data-cw-search-products-list]');
    var emptyEl = root.querySelector('[data-cw-search-empty]');
    var allLink = root.querySelector('[data-cw-search-all]');
    var clearBtn = root.querySelector('[data-cw-search-clear]');

    var openSearch = function () {
      if (root.hidden) cwLockScroll();
      root.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { root.classList.add('is-open'); });
      });
      window.setTimeout(function () { input.focus({ preventScroll: true }); }, 350);
    };
    var closeSearch = function () {
      if (!root.hidden) cwUnlockScroll();
      root.classList.remove('is-open');
      window.setTimeout(function () { root.hidden = true; }, 300);
    };

    /* przechwytujemy lupkę ZANIM Dawnowe <details> zdąży się otworzyć */
    document.addEventListener('click', function (event) {
      var summary = event.target.closest && event.target.closest('.header__search summary');
      if (summary) {
        event.preventDefault();
        event.stopPropagation();
        openSearch();
        return;
      }
      if (event.target.closest && event.target.closest('[data-cw-search-close]')) closeSearch();
    }, true);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !root.hidden) closeSearch();
    });

    var esc = function (t) {
      var d = document.createElement('div');
      d.textContent = t == null ? '' : String(t);
      return d.innerHTML;
    };
    var money = function (raw) {
      if (raw == null) return '';
      return cwMoney(raw);
    };
    var render = function (q, data) {
      var res = (data && data.resources && data.resources.results) || {};
      var queries = res.queries || [];
      var products = res.products || [];
      body.hidden = false;
      qWrap.hidden = queries.length === 0;
      qList.innerHTML = queries.slice(0, 5).map(function (item) {
        return '<a class="cw-search__chip" href="' + cwUrl('/search?type=product&q=' + encodeURIComponent(item.text)) + '">' + (item.styled_text || esc(item.text)) + '</a>';
      }).join('');
      pWrap.hidden = products.length === 0;
      pList.innerHTML = products.map(function (pr) {
        var img = pr.featured_image && pr.featured_image.url ? pr.featured_image.url : '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=180';
        return '<a class="cw-search__item" href="' + pr.url + '">'
          + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '')
          + '<span class="cw-search__item-info"><span class="cw-search__item-title">' + esc(pr.title) + '</span>'
          + '<span class="cw-search__item-price">' + money(pr.price) + '</span></span></a>';
      }).join('');
      emptyEl.hidden = queries.length > 0 || products.length > 0;
      allLink.hidden = products.length === 0;
      allLink.href = cwUrl('/search?type=product&q=' + encodeURIComponent(q));
    };

    var timer = null;
    var lastQ = '';
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearBtn.hidden = q === '';
      window.clearTimeout(timer);
      if (q === '') {
        body.hidden = true;
        lastQ = '';
        return;
      }
      timer = window.setTimeout(function () {
        if (q === lastQ) return;
        lastQ = q;
        fetch(cwUrl('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,query&resources[limit]=8&resources[options][unavailable_products]=last'))
          .then(function (r) { return r.json(); })
          .then(function (data) { if (input.value.trim() === q) render(q, data); })
          .catch(function () {});
      }, 250);
    });
    clearBtn.addEventListener('click', function () {
      input.value = '';
      clearBtn.hidden = true;
      body.hidden = true;
      lastQ = '';
      input.focus();
    });
  })();

  /* TYLKO podkreślone CTA (ODKRYJ NOWOŚCI, Wyświetl wszystkie): podjazd etykiety
     z dołu przy hoverze, podkreślenie stoi w miejscu. Pełne przyciski (Dodaj do
     koszyka itd.) BEZ tej animacji — decyzja Michała 6.08 */
  function enhanceRollButtons(root) {
    var scope = root || document;
    // (pozycje paska menu mają własny markup rolki w cw-mega-menu.liquid)
    var candidates = scope.querySelectorAll('.cw-hero__btn, .underlined-link');
    Array.prototype.forEach.call(candidates, function (btn) {
      if (btn.classList.contains('cw-roll')) return;
      var label = null;
      var spans = Array.prototype.filter.call(btn.children, function (c) {
        return c.tagName === 'SPAN' && !c.classList.contains('visually-hidden') && c.textContent.trim();
      });
      if (spans.length === 1) {
        label = spans[0];
      } else if (btn.children.length === 0 && btn.textContent.trim()) {
        label = document.createElement('span');
        label.textContent = btn.textContent.trim();
        btn.textContent = '';
        btn.appendChild(label);
      }
      if (!label) return;
      label.classList.add('cw-roll__label');
      label.dataset.text = label.textContent.trim();
      /* okno tnące DOKŁADNIE 1 linię: bez niego czubki diakrytyków (Ś)
         drugiej kopii wystawały w strefę paddingu podkreślenia (28.08) */
      var win = document.createElement('span');
      win.className = 'cw-roll__win';
      btn.insertBefore(win, label);
      win.appendChild(label);
      btn.classList.add('cw-roll');
    });
  }
  enhanceRollButtons(document);

  /* Animacja paska darmowej dostawy: po otwarciu koszyka (i po każdym re-renderze)
     wypełnienie narasta od zera do wartości wyrenderowanej przez serwer */
  function animateFsBars() {
    document.querySelectorAll('cart-drawer .cw-cart__fs-bar span').forEach(function (span) {
      var target = span.style.width;
      if (!target || span.dataset.cwShown === target) return;
      span.dataset.cwShown = target;
      span.style.transition = 'none';
      span.style.width = '0%';
      void span.offsetWidth;
      span.style.transition = 'width 0.8s cubic-bezier(0.4, 0, 0.2, 1)';
      span.style.width = target;
    });
  }
  {
    var cwDrawer = document.querySelector('cart-drawer');
    if (cwDrawer) {
      new MutationObserver(function () {
        if (cwDrawer.classList.contains('active')) animateFsBars();
      }).observe(cwDrawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    }
  }

  /* Akordeon RABAT: płynne rozwijanie/zwijanie (details nie animuje się samo) */
  document.addEventListener('click', function (event) {
    var summary = event.target.closest('.cw-cart__acc > summary');
    if (!summary) return;
    event.preventDefault();
    var acc = summary.parentElement;
    var body = acc.querySelector('.cw-cart__acc-body');
    if (!body) {
      acc.open = !acc.open;
      return;
    }
    // klik w trakcie animacji szarpał przebieg — ignorujemy do jej końca
    if (body.classList.contains('cw-animating')) return;
    body.classList.add('cw-animating');
    var finished = false;
    var finish = function () {
      if (finished) return;
      finished = true;
      body.removeEventListener('transitionend', finish);
      if (body.style.height === '0px') acc.open = false;
      body.classList.remove('cw-animating');
      body.style.height = '';
    };
    // transitionend potrafi nie dolecieć (re-render, ukryty element) — sprzątamy też po czasie
    window.setTimeout(finish, 450);
    if (acc.open) {
      body.style.height = body.scrollHeight + 'px';
      void body.offsetHeight;
      body.style.height = '0px';
    } else {
      acc.open = true;
      body.style.height = '0px';
      void body.offsetHeight;
      body.style.height = body.scrollHeight + 'px';
    }
    body.addEventListener('transitionend', finish);
  });

  /* Kod rabatowy: naliczany OD RAZU w koszyku (Cart Ajax API + re-render sekcji);
     gdy sklep nie przyjmie kodu przez Ajax — fallback /discount/KOD (naliczy się w kasie) */
  {
    var refreshCartSections = function (keepAccOpen) {
      return fetch(cwUrl('/?sections=cart-drawer,cart-icon-bubble'))
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var fresh = doc.querySelector('.drawer__inner');
          var current = document.querySelector('cart-drawer .drawer__inner');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && sections['cart-icon-bubble']) bubble.innerHTML = sections['cart-icon-bubble'];
          if (keepAccOpen) {
            var acc = document.querySelector('.cw-cart__acc');
            if (acc) acc.open = true;
          }
          animateFsBars();
        });
    };

    document.addEventListener('click', function (event) {
      var applyBtn = event.target.closest('[data-cw-apply-discount]');
      if (!applyBtn) return;
      var input = document.getElementById('CwCartDiscount');
      var code = input ? input.value.trim() : '';
      if (!code) return;
      var showMsg = function (text, isError) {
        var el = document.querySelector('[data-cw-disc-msg]');
        if (!el) return;
        el.hidden = false;
        el.textContent = text;
        el.classList.toggle('is-error', !!isError);
      };
      applyBtn.disabled = true;
      fetch(cwUrl('/cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code }),
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var dc = (cart.discount_codes || []).filter(function (d) {
            return d.code && d.code.toLowerCase() === code.toLowerCase();
          })[0];
          if (!dc) {
            window.location.href = cwUrl('/discount/' + encodeURIComponent(code)) + '?return_to=' + encodeURIComponent(window.location.pathname);
            return;
          }
          if (dc.applicable === false) {
            showMsg(cwStr.discountInvalid || 'Nie można dodać kodu rabatowego do Twojego koszyka', true);
            applyBtn.disabled = false;
            // nieudany kod nie może zostać w koszyku (wisiałby też w kasie)
            fetch(cwUrl('/cart/update.js'), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ discount: '' }),
            });
            return;
          }
          // sukcesu nie ogłaszamy tekstem — pokazuje go chip kuponu przy RABAT
          return refreshCartSections(true);
        })
        .catch(function () { applyBtn.disabled = false; });
    });

    // usunięcie zastosowanego kodu (× na chipie kuponu)
    document.addEventListener('click', function (event) {
      var removeBtn = event.target.closest('[data-cw-remove-discount]');
      if (!removeBtn) return;
      removeBtn.disabled = true;
      fetch(cwUrl('/cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' }),
      })
        .then(function () { return refreshCartSections(true); })
        .catch(function () { removeBtn.disabled = false; });
    });
    // monit błędu znika, gdy klient zaczyna poprawiać kod
    document.addEventListener('input', function (event) {
      if (event.target && event.target.id === 'CwCartDiscount') {
        var el = document.querySelector('[data-cw-disc-msg]');
        if (el) el.hidden = true;
      }
    });
    document.querySelectorAll('.search-modal input[type="search"]').forEach(function (input) {
      input.addEventListener('input', syncDefaultVisibility);
    });
  }

  /* Suwak ceny w panelu FILTR (wzór Michała 19.08): dual-range zsynchronizowany
     z polami Dawna (commit na puszczeniu uchwytu → change → AJAX Dawna).
     Re-init po każdej AJAX-owej podmianie facetów. */
  var cwInitPriceSliders = function () {
    document.querySelectorAll('price-range.facets__price').forEach(function (pr) {
      if (pr.querySelector('.cw-range')) return;
      var inputs = pr.querySelectorAll('.field__input');
      if (inputs.length < 2) return;
      var minF = inputs[0];
      var maxF = inputs[1];
      var parseNum = function (v, def) {
        var n = parseFloat(String(v == null ? '' : v).replace(/\s/g, '').replace(',', '.'));
        return isNaN(n) ? def : n;
      };
      var maxVal = Math.ceil(parseNum(maxF.dataset.max, 0));
      if (!maxVal) return;
      // separator „do" między polami (tekst z ukrytej etykiety pola LTE)
      var sep = document.createElement('span');
      sep.className = 'cw-price-sep';
      var lteLabel = maxF.parentElement.querySelector('.field__label');
      sep.textContent = (lteLabel ? lteLabel.textContent.trim() : 'do').toLowerCase();
      pr.insertBefore(sep, maxF.parentElement.previousElementSibling || maxF.parentElement);
      // suwak
      var wrap = document.createElement('div');
      wrap.className = 'cw-range';
      wrap.innerHTML =
        '<div class="cw-range__track"></div><div class="cw-range__fill"></div>' +
        '<input type="range" data-cw-thumb="min" min="0" max="' + maxVal + '" step="1" aria-hidden="true">' +
        '<input type="range" data-cw-thumb="max" min="0" max="' + maxVal + '" step="1" aria-hidden="true">';
      pr.insertBefore(wrap, pr.firstChild);
      var rMin = wrap.querySelector('[data-cw-thumb="min"]');
      var rMax = wrap.querySelector('[data-cw-thumb="max"]');
      var fill = wrap.querySelector('.cw-range__fill');
      var paint = function () {
        var a = Math.min(+rMin.value, +rMax.value);
        var b = Math.max(+rMin.value, +rMax.value);
        fill.style.left = (a / maxVal) * 100 + '%';
        fill.style.right = (100 - (b / maxVal) * 100) + '%';
      };
      var syncFromFields = function () {
        rMin.value = parseNum(minF.value, 0);
        rMax.value = parseNum(maxF.value, maxVal);
        paint();
      };
      var commit = function () {
        var a = Math.min(+rMin.value, +rMax.value);
        var b = Math.max(+rMin.value, +rMax.value);
        minF.value = a > 0 ? a : '';
        maxF.value = b < maxVal ? b : '';
        maxF.dispatchEvent(new Event('input', { bubbles: true }));
      };
      rMin.addEventListener('input', paint);
      rMax.addEventListener('input', paint);
      rMin.addEventListener('change', commit);
      rMax.addEventListener('change', commit);
      minF.addEventListener('input', syncFromFields);
      maxF.addEventListener('input', syncFromFields);
      syncFromFields();
    });
  };
  /* Wybrane filtry widoczne jak GSQ: FILTR (N) + chipy z × pod nagłówkiem +
     liczniki przy sekcjach + „(N)" na pasku + stopka z WYCZYŚĆ WSZYSTKO */
  var cwDecorating = false;
  var cwFacetsDecorate = function () {
    if (cwDecorating) return;
    cwDecorating = true;
    document.querySelectorAll('.mobile-facets__wrapper').forEach(function (w) {
      var inner = w.querySelector('.mobile-facets__inner');
      // poboczne warianty formy (bez nagłówka) pomijamy
      if (!inner || !inner.querySelector('.mobile-facets__header')) return;
      var total = 0;
      var active = []; // {label, clear()}
      inner.querySelectorAll('.mobile-facets__details').forEach(function (det) {
        var count = 0;
        det.querySelectorAll('input.mobile-facets__checkbox:checked').forEach(function (i) {
          count++;
          var lbl = i.closest('label');
          var txt = lbl ? (lbl.textContent.trim().replace(/\s+/g, ' ').split(' (')[0]) : i.value;
          active.push({ label: txt, clear: function () { i.checked = false; i.dispatchEvent(new Event('input', { bubbles: true })); } });
        });
        var priceInputs = det.querySelectorAll('price-range .field__input');
        if (priceInputs.length === 2 && (priceInputs[0].value || priceInputs[1].value)) {
          count++;
          var a = priceInputs[0].value || '0';
          var b = priceInputs[1].value || (priceInputs[1].getAttribute('placeholder') || '');
          active.push({ label: (cwStr.priceLabel || 'Cena') + ': ' + a + '–' + b + ' ' + (cwStr.currencySymbol || 'zł'), clear: function () {
            priceInputs[0].value = ''; priceInputs[1].value = '';
            priceInputs[1].dispatchEvent(new Event('input', { bubbles: true }));
          } });
        }
        total += count;
        // badge przy sekcji
        var summary = det.querySelector(':scope > summary');
        if (!summary) return;
        var badge = summary.querySelector('.cw-facet-count');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cw-facet-count';
          summary.appendChild(badge);
        }
        badge.textContent = count > 0 ? count : '';
      });
      // FILTR (N)
      inner.querySelectorAll('.mobile-facets__heading').forEach(function (h) {
        var c = h.querySelector('.cw-filtr-count');
        if (!c) { c = document.createElement('span'); c.className = 'cw-filtr-count'; h.appendChild(c); }
        c.textContent = total > 0 ? '(' + total + ')' : '';
      });
      // chipy pod nagłówkiem
      var chips = inner.querySelector('.cw-active-chips');
      if (!chips) {
        chips = document.createElement('div');
        chips.className = 'cw-active-chips';
        var header = inner.querySelector('.mobile-facets__header');
        header.insertAdjacentElement('afterend', chips);
      }
      chips.innerHTML = '';
      active.forEach(function (a) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'cw-chip';
        chip.innerHTML = '<span></span><svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M2 2l8 8M10 2l-8 8"/></svg>';
        chip.querySelector('span').textContent = a.label;
        chip.addEventListener('click', a.clear);
        chips.appendChild(chip);
      });
      // stopka: WYCZYŚĆ WSZYSTKO tylko przy aktywnych
      w.classList.toggle('cw-has-active', total > 0);
      // pasek: FILTR I SORTOWANIE (N)
      var openLabel = w.querySelector('.mobile-facets__open-label.small-hide');
      if (openLabel) {
        var base = openLabel.getAttribute('data-cw-base') || openLabel.textContent.trim();
        openLabel.setAttribute('data-cw-base', base);
        openLabel.textContent = total > 0 ? base + ' (' + total + ')' : base;
      }
    });
    window.setTimeout(function () { cwDecorating = false; }, 0);
  };
  cwInitPriceSliders();
  cwFacetsDecorate();
  ['input','change'].forEach(function (evt) {
    document.addEventListener(evt, function (event) {
      if (event.target.closest && event.target.closest('.mobile-facets__wrapper')) {
        window.setTimeout(cwFacetsDecorate, 50);
      }
    });
  });
  var cwFacetsRoot = document.getElementById('main-collection-filters');
  if (cwFacetsRoot) {
    new MutationObserver(function () { cwInitPriceSliders(); cwFacetsDecorate(); })
      .observe(cwFacetsRoot, { childList: true, subtree: true });
  }

  /* × panelu FILTR: Dawnowy close żyje w summary PASKA — przenosimy do nagłówka
     panelu (jak GSQ) i podpinamy zamykanie przez klik w summary */
  document.querySelectorAll('.mobile-facets__wrapper').forEach(function (w) {
    var close = w.querySelector('.mobile-facets__close');
    var headerInner = w.querySelector('.mobile-facets__header-inner') || w.querySelector('.mobile-facets__header');
    if (close && headerInner && !headerInner.contains(close)) {
      headerInner.appendChild(close);
      close.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var s = w.querySelector('summary');
        if (s) s.click();
      });
    }
  });

  /* ── Pasek kolekcji: przełącznik widoku siatki (ikonki bez cyfr, 21.08) —
     mobile: 2 kolumny ↔ 1 kolumna, desktop: luźno ↔ gęsto; krótki fade gridu ── */
  {
    var collGrid = document.getElementById('product-grid');
    if (collGrid && document.querySelector('.cw-collbar__density')) {
      var applyDensity = function (mode, animate) {
        var swap = function () {
          collGrid.classList.toggle('cw-grid-dense', mode === 'dense');
          document.querySelectorAll('.cw-collbar__dbtn').forEach(function (b) {
            b.classList.toggle('is-active', b.getAttribute('data-cw-density') === mode);
          });
        };
        if (!animate) return swap();
        collGrid.classList.add('cw-grid-fading');
        window.setTimeout(function () {
          swap();
          collGrid.classList.remove('cw-grid-fading');
        }, 180);
      };
      try {
        applyDensity(localStorage.getItem('cw:grid-density') || 'loose', false);
      } catch (e) {}
      document.addEventListener('click', function (event) {
        var d = event.target.closest('[data-cw-density]');
        if (!d) return;
        var mode = d.getAttribute('data-cw-density');
        applyDensity(mode, true);
        try { localStorage.setItem('cw:grid-density', mode); } catch (e) {}
      });
    }
  }

  /* ── Mega menu kaskadowe (desktop): hover otwiera pozycję paska (details Dawna
     robi klik/Escape/klik-poza), hover na pozycji z dziećmi odsłania 3. kolumnę,
     backdrop przyciemnia stronę. Bez własnego stanu — źródłem prawdy jest [open]. */
  {
    var megaBackdrop = document.querySelector('[data-cw-mega-backdrop]');
    var megaItems = document.querySelectorAll('.cw-mega__item');
    var megaSync = function () {
      var anyOpen = !!document.querySelector('.cw-mega__details[open]');
      if (megaBackdrop) {
        megaBackdrop.hidden = false;
        megaBackdrop.classList.toggle('is-on', anyOpen);
      }
      document.body.classList.toggle('cw-mega-open', anyOpen);
    };
    var megaCloseAll = function (except) {
      document.querySelectorAll('.cw-mega__details[open]').forEach(function (d) {
        if (d !== except) d.removeAttribute('open');
      });
      megaSync();
    };
    var megaShowSlot = function (panel, trigger) {
      panel.querySelectorAll('.cw-mega__trigger').forEach(function (t) {
        t.setAttribute('aria-expanded', t === trigger ? 'true' : 'false');
      });
      panel.querySelectorAll('.cw-mega__col--child').forEach(function (col) {
        col.hidden = !trigger || col.id !== trigger.getAttribute('aria-controls');
      });
    };

    megaItems.forEach(function (item) {
      var details = item.querySelector('.cw-mega__details');
      if (!details) return;
      var panel = details.querySelector('.cw-mega__panel');
      // domyślnie otwarta pierwsza kolumna-dziecko (jak GSQ: kaskada od razu widoczna)
      var firstTrigger = panel.querySelector('.cw-mega__trigger');
      if (firstTrigger) megaShowSlot(panel, firstTrigger);

      // 21.08 (decyzja Michała): otwieranie KLIKIEM, nie hoverem — natywny
      // toggle <details>; przy otwieraniu zamykamy pozostałe pozycje
      details.querySelector('summary').addEventListener('click', function () {
        if (!details.hasAttribute('open')) megaCloseAll(details);
      });
      panel.querySelectorAll('.cw-mega__trigger').forEach(function (t) {
        t.addEventListener('mouseenter', function () { megaShowSlot(panel, t); });
        t.addEventListener('click', function () { megaShowSlot(panel, t); });
        t.addEventListener('focus', function () { megaShowSlot(panel, t); });
      });
      details.addEventListener('toggle', megaSync);
    });
    if (megaBackdrop) {
      megaBackdrop.addEventListener('click', function () { megaCloseAll(); });
    }
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') megaCloseAll();
    });
  }

  /* ── Quick Add: popup wyboru rozmiaru (desktop modal / mobile bottom sheet) ──
     Dane z /products/HANDLE.js; dodanie przez /cart/add.js z sections —
     renderContents() Dawnowego cart-drawer podmienia koszyk i sam go otwiera */
  {
    var qaRoot = document.getElementById('CwQuickAdd');
    if (qaRoot) {
      var qaSelected = null;
      var qaMoney = function (cents) {
        return cwMoney(cents / 100);
      };
      var qaOpen = function () {
        if (qaRoot.hidden) cwLockScroll();
        qaRoot.hidden = false;
        document.body.classList.add('cw-qa-modal-open');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { qaRoot.classList.add('is-open'); });
        });
      };
      var qaClose = function () {
        if (!qaRoot.hidden) cwUnlockScroll();
        qaRoot.classList.remove('is-open');
        document.body.classList.remove('cw-qa-modal-open');
        window.setTimeout(function () { qaRoot.hidden = true; }, 300);
      };
      /* 28.08: zdjecia w modalu laduja sie z opoznieniem (fetch JSON +
         obrazy 600px, ktorych nie ma w cache) — trzy remedia:
         1) cache JSON per handle, 2) prefetch na hover/touchstart plusa,
         3) pierwszy kadr = obraz JUZ ZALADOWANY na karcie (currentSrc) */
      var qaCache = {};
      var qaFetch = function (handle) {
        if (!qaCache[handle]) {
          qaCache[handle] = fetch(cwUrl('/products/' + handle + '.js')).then(function (r) {
            if (!r.ok) throw new Error('http');
            return r.json();
          });
          qaCache[handle].catch(function () { delete qaCache[handle]; });
        }
        return qaCache[handle];
      };
      var qaWarmImages = function (p) {
        (p.images || []).slice(0, 2).forEach(function (src) {
          var im = new Image();
          im.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=600';
        });
      };
      ['mouseover', 'touchstart', 'focusin'].forEach(function (type) {
        document.addEventListener(type, function (event) {
          var opener = event.target.closest && event.target.closest('[data-cw-qa]');
          if (!opener) return;
          qaFetch(opener.getAttribute('data-cw-qa')).then(qaWarmImages).catch(function () {});
        }, { passive: true });
      });

      /* 30.08: dogrzewanie HERO ZDJĘCIA PDP przy hover/dotyku karty —
         na PDP pierwsze zdjęcie to inny plik (większy width) niż na karcie,
         więc bez tego wejście w nieodwiedzany produkt = biała plansza ~1s.
         Szerokość liczona jak sizes galerii (mobile 100vw, desktop ~65% vw). */
      var cwHeroWarmed = {};
      var cwHeroLadder = [246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946];
      var cwWarmHero = function (event) {
        /* zdjęcie karty leży POZA <a> (stretched link Dawna) — kotwiczymy
           na całej karcie, nie na linku */
        var card = event.target.closest && event.target.closest('.card-wrapper');
        if (!card || !card.querySelector('a[href*="/products/"]')) return;
        var img = card.querySelector('.card__media img');
        if (!img || !img.currentSrc) return;
        var base = img.currentSrc.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
        if (cwHeroWarmed[base]) return;
        cwHeroWarmed[base] = true;
        var cssW = window.innerWidth < 750 ? window.innerWidth : window.innerWidth * 0.65;
        var need = cssW * (window.devicePixelRatio || 1);
        var w = cwHeroLadder.find(function (x) { return x >= need; }) || 1946;
        var im = new Image();
        im.src = base + (base.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
      };
      ['mouseover', 'touchstart', 'focusin'].forEach(function (type) {
        document.addEventListener(type, cwWarmHero, { passive: true });
      });

      var qaFill = function (p, cardSrc) {
        qaSelected = null;
        qaRoot.querySelector('[data-cw-qa-title]').textContent = p.title;
        qaRoot.querySelector('[data-cw-qa-price]').textContent = qaMoney(p.price);
        var cmp = qaRoot.querySelector('[data-cw-qa-compare]');
        if (p.compare_at_price && p.compare_at_price > p.price) {
          cmp.hidden = false;
          cmp.textContent = qaMoney(p.compare_at_price);
        } else {
          cmp.hidden = true;
        }
        var media = qaRoot.querySelector('[data-cw-qa-media]');
        media.innerHTML = '';
        (p.images || []).slice(0, 2).forEach(function (src, i) {
          var img = document.createElement('img');
          var full = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=600';
          if (i === 0 && cardSrc) {
            /* kadr z karty jest w cache — modal ma zdjecie NATYCHMIAST;
               docelowa 600-tka dociaga sie w tle i podmienia po load */
            img.src = cardSrc;
            var hi = new Image();
            hi.onload = function () { img.src = full; };
            hi.src = full;
          } else {
            img.src = full;
          }
          img.alt = p.title;
          img.loading = 'eager';
          media.appendChild(img);
        });
        // options bywa tablicą stringów (legacy) lub obiektów {name, values}
        var qaOpt = p.options && p.options[0];
        qaRoot.querySelector('[data-cw-qa-option-label]').textContent = (qaOpt && qaOpt.name) || (typeof qaOpt === 'string' ? qaOpt : 'Rozmiar');
        qaRoot.querySelector('[data-cw-qa-url]').setAttribute('href', p.url);
        qaRoot.querySelector('[data-cw-qa-error]').hidden = true;
        var sizes = qaRoot.querySelector('[data-cw-qa-sizes]');
        sizes.innerHTML = '';
        p.variants.forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'cw-qa__size';
          b.textContent = v.option1;
          b.disabled = !v.available;
          b.addEventListener('click', function () {
            qaSelected = v;
            sizes.querySelectorAll('.cw-qa__size').forEach(function (x) { x.classList.remove('is-active'); });
            b.classList.add('is-active');
            qaRoot.querySelector('[data-cw-qa-error]').hidden = true;
          });
          sizes.appendChild(b);
        });
        var firstAvailable = sizes.querySelector('.cw-qa__size:not(:disabled)');
        if (firstAvailable) firstAvailable.click();
      };
      document.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-cw-qa]');
        if (opener) {
          event.preventDefault();
          var handle = opener.getAttribute('data-cw-qa');
          var cardInner = opener.closest('.card__inner') || opener.closest('.card-wrapper');
          var cardImg = cardInner && cardInner.querySelector('.card__media .media img');
          var cardSrc = cardImg ? cardImg.currentSrc || cardImg.src : null;
          qaFetch(handle)
            .then(function (p) { qaFill(p, cardSrc); qaOpen(); })
            .catch(function () { window.location.href = '/products/' + handle; });
          return;
        }
        if (event.target.closest('[data-cw-qa-close]')) {
          qaClose();
          return;
        }
        var atc = event.target.closest('[data-cw-qa-atc]');
        if (!atc) return;
        var errorEl = qaRoot.querySelector('[data-cw-qa-error]');
        if (!qaSelected) {
          errorEl.hidden = false;
          return;
        }
        atc.classList.add('is-loading');
        var drawer = document.querySelector('cart-drawer');
        var sections = drawer && drawer.getSectionsToRender
          ? drawer.getSectionsToRender().map(function (s) { return s.id; })
          : ['cart-drawer', 'cart-icon-bubble'];
        fetch(cwUrl('/cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: qaSelected.id, quantity: 1, sections: sections, sections_url: window.location.pathname }),
        })
          .then(function (r) { return r.json(); })
          .then(function (resp) {
            atc.classList.remove('is-loading');
            if (resp.status) {
              errorEl.hidden = false;
              errorEl.textContent = resp.description || resp.message || cwStr.addError || 'Nie udało się dodać do koszyka.';
              return;
            }
            qaClose();
            if (drawer && drawer.renderContents) drawer.renderContents(resp);
            animateFsBars();
          })
          .catch(function () { atc.classList.remove('is-loading'); });
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !qaRoot.hidden) qaClose();
      });
    }
  }

  /* ── Blokada scrolla strony pod overlayami (menu, koszyk, quick add) ──
     iOS Safari ignoruje overflow:hidden na body — jedyny pewny lock to
     position:fixed z zapamiętanym scrollY (licznik, bo overlaye się przeplatają) */
  var cwLockCount = 0;
  var cwLockY = 0;
  function cwLockScroll() {
    cwLockCount++;
    if (cwLockCount > 1) return;
    cwLockY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = -cwLockY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function cwUnlockScroll() {
    if (!cwLockCount) return;
    cwLockCount--;
    if (cwLockCount) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, cwLockY);
  }
  /* koszyk: lock spięty z KLASĄ .active (MutationObserver), nie z metodami
     open/close — Dawnowy overlay trzyma close zbindowane w konstruktorze,
     więc patch metod gubił zamknięcie klikiem w tło (bug 22.08 v2) */
  (function () {
    var cwCd = document.querySelector('cart-drawer');
    if (!cwCd) return;
    var cwCdWasActive = cwCd.classList.contains('active');
    new MutationObserver(function () {
      var isActive = cwCd.classList.contains('active');
      if (isActive === cwCdWasActive) return;
      cwCdWasActive = isActive;
      if (isActive) cwLockScroll();
      else cwUnlockScroll();
    }).observe(cwCd, { attributes: true, attributeFilter: ['class'] });
  })();

  /* Dawn przy dodaniu do koszyka zdejmuje is-empty tylko z .drawer__inner —
     klasa zostawała na <cart-drawer> i nasze selektory pustego stanu chowały
     świeżo dodane produkty (każda ścieżka dodawania przy pustym koszyku) */
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(function () {
      var cwDrawer = document.querySelector('cart-drawer');
      if (!cwDrawer || !cwDrawer.renderContents) return;
      var cwOrigRender = cwDrawer.renderContents.bind(cwDrawer);
      cwDrawer.renderContents = function (parsedState) {
        this.classList.remove('is-empty');
        return cwOrigRender(parsedState);
      };
    });
  }

  /* Uwagi do zamówienia (drawer): zapis note z debounce; DELEGACJA na
     document — renderContents podmienia DOM drawera i gubi zwykłe listenery */
  var cwNoteTimer = null;
  document.addEventListener('input', function (event) {
    var note = event.target.closest && event.target.closest('[data-cw-cart-note]');
    if (!note) return;
    window.clearTimeout(cwNoteTimer);
    cwNoteTimer = window.setTimeout(function () {
      fetch(cwUrl('/cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value }),
      })
        .then(function (r) {
          if (!r.ok) return;
          var msg = document.querySelector('[data-cw-note-msg]');
          if (msg) {
            msg.hidden = false;
            window.setTimeout(function () { msg.hidden = true; }, 1500);
          }
        })
        .catch(function () {});
    }, 600);
  });

  /* Kółeczko na ZREALIZUJ ZAKUP w czasie przejścia do kasy */
  document.addEventListener('click', function (event) {
    var checkoutBtn = event.target.closest('#CartDrawer-Checkout');
    if (checkoutBtn && !checkoutBtn.disabled) checkoutBtn.classList.add('is-loading');
  });
  // powrót z kasy przyciskiem wstecz (bfcache) — spinner ma zniknąć
  window.addEventListener('pageshow', function (event) {
    document.querySelectorAll('.cw-cart__checkout.is-loading').forEach(function (btn) {
      btn.classList.remove('is-loading');
    });
    /* 16.09: Safari po przywróceniu z bfcache potrafi NIE namalować sekcji
       opinii (pojawiała się dopiero po scrollu) — wymuszamy repaint */
    if (event && event.persisted) {
      var op = document.querySelector('[data-cw-op].cw-op-ready');
      if (op) {
        op.style.display = 'none';
        void op.offsetHeight;
        op.style.display = '';
      }
    }
  });

  /* ══ Weryfikacja ocen TrustMate per produkt (03.09 v2) ══
     Metapole reviews.rating potrafi kłamać (GIA czekoladowa: 5.0/count 1,
     a widget bez żadnej opinii) — gwiazdki NIGDZIE nie pokazują się bez
     potwierdzenia. Sędziowie: 1) cache werdyktu (localStorage cw:oprv2:handle),
     2) endpoint TrustMate api/widget/UUID/script?group=<id> (CORS *, pusty
     body = zero opinii — sprawdzone: LAURA 15KB / GIA czekoladowa 0B),
     3) na PDP dodatkowo harvester sekcji opinii (cw-opr-ready/none). */
  /* Endpointy TrustMate (16.09, v2): W1 (hornet, mały) bywa NIEpusty dla
     produktów z opiniami wyłącznie GRUPOWYMI (kolory KARY/ZOYI), których
     hydra nie pokazuje — dlatego dwustopniowo: W1 pusty = brak (tanio),
     W1 niepusty = decyduje payload hydry W2: liczba znaczników
     data-tm-grade-review to liczba REALNIE wyświetlanych opinii
     (zmierzone: LAURA 5, GWEN 1, NAYA 0, KARA śmietanowa 0).
     Werdykty w cw:oprv2: (prefix v2 unieważnia stare, błędne "1"). */
  /* host .io BEZPOŚREDNIO: .pro potrafi oddać 301 bez nagłówka CORS
     (przeglądarka wymaga go na każdym kroku łańcucha) → losowe
     Failed to fetch i karty bez werdyktu (16.09) */
  var CW_TM_W1 = '3ae24877-9f2a-46f0-a9dc-4f0ba011126b';
  var CW_TM_W2 = '7d45df72-cfe6-4729-8a0d-94f6b0131869';
  var cwTmQueue = [];
  var cwTmActive = 0;
  var cwTmSeen = {};
  var cwCardHandle = function (el) {
    var wrap = el.closest('.card-wrapper') || el.closest('li') || el.parentElement;
    var a = wrap ? wrap.querySelector('a[href*="/products/"]') : null;
    var m = a && (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  };
  var cwCardRatingHide = function (handle) {
    document.querySelectorAll('.cw-card-rating').forEach(function (el) {
      if (cwCardHandle(el) === handle) el.remove();
    });
  };
  var cwTmRun = function (item) {
    cwTmActive += 1;
    (item.pid
      ? Promise.resolve({ id: item.pid })
      : fetch(cwUrl('/products/' + encodeURIComponent(item.h) + '.js')).then(function (r) { return r.json(); })
    )
      .then(function (p) {
        return fetch('https://trustmate.io/api/widget/' + CW_TM_W1 + '/script?group=' + p.id)
          .then(function (r) { return r.text(); })
          .then(function (t1) {
            if (!t1.trim()) return false; /* W1 pusty = na pewno brak opinii */
            return fetch('https://trustmate.io/api/widget/' + CW_TM_W2 + '/script?group=' + p.id)
              .then(function (r) { return r.text(); })
              .then(function (t2) { return t2.indexOf('data-tm-grade-review') > -1; });
          });
      })
      .then(function (has) {
        try { localStorage.setItem('cw:oprv2:' + item.h, has ? '1' : '0'); } catch (e) {}
        if (!has) cwCardRatingHide(item.h);
        if (item.cb) item.cb(has);
      })
      /* błąd sieci = bez werdyktu (fail-open) — retry przy kolejnej odsłonie */
      .catch(function () {})
      .then(function () {
        cwTmActive -= 1;
        window.setTimeout(cwTmPump, 100);
      });
  };
  var cwTmPump = function () {
    while (cwTmActive < 3 && cwTmQueue.length) cwTmRun(cwTmQueue.shift());
  };
  window.cwTmVerify = function (handle, cb, opts) {
    if (!handle || cwTmSeen[handle]) return;
    cwTmSeen[handle] = true;
    var item = { h: handle, cb: cb, pid: opts && opts.pid };
    if (opts && opts.priority) cwTmQueue.unshift(item);
    else cwTmQueue.push(item);
    cwTmPump();
  };
  var cwCardRatingSync = function () {
    document.querySelectorAll('.cw-card-rating').forEach(function (el) {
      var h = cwCardHandle(el);
      if (!h) return;
      var v = null;
      try { v = localStorage.getItem('cw:oprv2:' + h); } catch (e) {}
      if (v === '0') el.remove();
      else if (v === null) window.cwTmVerify(h, null, { pid: el.getAttribute('data-cw-pid') });
    });
  };
  /* start po ticku — blok oceny PDP (niżej) musi zdążyć wrzucić się na początek kolejki */
  window.setTimeout(cwCardRatingSync, 0);
  if (window.MutationObserver) {
    var cwCrTimer = null;
    new MutationObserver(function () {
      window.clearTimeout(cwCrTimer);
      cwCrTimer = window.setTimeout(cwCardRatingSync, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* PDP: ocena przy cenie — renderowana UKRYTA (Liquid), odkrywana po weryfikacji */
  (function () {
    var link = document.querySelector('[data-cw-rating]');
    if (!link) return;
    var handle = link.getAttribute('data-cw-rating') || (window.location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || '';
    /* NIGDY bez liczby (07.09, NAYA): metapole bywa puste, choć endpoint
       twierdzi, że opinie są (grupowe „podobne produkty") — odsłaniamy
       wyłącznie, gdy w linku jest wartość */
    var hasVal = function () {
      var v = link.querySelector('[data-cw-rating-value]');
      return !!(v && v.textContent.trim());
    };
    var verdict = null;
    try { verdict = localStorage.getItem('cw:oprv2:' + handle); } catch (e) {}
    if (verdict === '1' && hasVal()) link.hidden = false;
    else if (verdict === null && handle) {
      window.cwTmVerify(handle, function (has) { if (has && hasVal()) link.hidden = false; }, {
        priority: true,
        pid: link.getAttribute('data-cw-pid'),
      });
    }
    var timer = window.setInterval(function () {
      var html = document.documentElement;
      if (html.classList.contains('cw-opr-ready')) {
        var src = document.querySelector('.hydra-grade__value');
        var txt = src ? (src.textContent || '').trim().replace(',', '.') : '';
        if (/^\d(\.\d)?$/.test(txt)) link.querySelector('[data-cw-rating-value]').textContent = txt;
        if (hasVal()) link.hidden = false;
        window.clearInterval(timer);
      } else if (html.classList.contains('cw-opr-none')) {
        link.hidden = true;
        window.clearInterval(timer);
      }
    }, 400);
  })();
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-cw-rating]');
    if (!link) return;
    event.preventDefault();
    var target = document.querySelector('[data-cw-opr]:not([hidden])') || document.querySelector('.tm-hydra') || document.querySelector('.tm-widget');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* Koszyk (28.08): zdjęcie pozycji grzejemy PRZY KLIKU w ATC — drawer
     po renderContents pokazywał pustą miniaturę, aż CDN dowiózł 252px */
  document.addEventListener('click', function (event) {
    var isAtc = event.target.closest && (event.target.closest('.product-form__submit') || event.target.closest('[data-cw-qa-atc]') || event.target.closest('[data-cw-sticky-btn]'));
    if (!isAtc) return;
    var og = document.querySelector('meta[property="og:image"]');
    if (og && og.content) {
      var im = new Image();
      im.src = og.content.replace(/(\?|&)width=\d+/, '') + (og.content.indexOf('?') > -1 ? '&' : '?') + 'width=252';
    }
  }, true);

  /* ── HERO SLIDER (15.09): crossfade co 6 s, kropki, swipe; pauza na
     hover, 12 s po interakcji, poza kadrem, na ukrytej karcie i przy
     prefers-reduced-motion. Start rotacji dopiero po window.load
     (LCP pierwszego slajdu bez konkurencji). ── */
  (function () {
    var hero = document.querySelector('[data-cw-hero-slider]');
    if (!hero) return;
    var slides = hero.querySelectorAll('[data-cw-hero-slide]');
    var dots = hero.querySelectorAll('[data-cw-hero-dot]');
    if (slides.length < 2) return;
    var current = 0;
    var hover = false;
    var inView = true;
    var holdUntil = 0;
    var hold = function () { holdUntil = Date.now() + 12000; };
    var go = function (i) {
      current = ((i % slides.length) + slides.length) % slides.length;
      Array.prototype.forEach.call(slides, function (s, idx) {
        s.classList.toggle('is-active', idx === current);
      });
      Array.prototype.forEach.call(dots, function (d, idx) {
        d.classList.toggle('is-active', idx === current);
      });
    };
    hero.addEventListener('pointerenter', function () { hover = true; });
    hero.addEventListener('pointerleave', function () { hover = false; });
    Array.prototype.forEach.call(dots, function (d, idx) {
      d.addEventListener('click', function () {
        hold();
        go(idx);
      });
    });
    /* swipe (mobile): poziomy gest > 40px zmienia slajd */
    var touchX = null;
    hero.addEventListener('touchstart', function (event) {
      touchX = event.touches[0].clientX;
    }, { passive: true });
    hero.addEventListener('touchend', function (event) {
      if (touchX === null) return;
      var dx = event.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) < 40) return;
      hold();
      go(current + (dx < 0 ? 1 : -1));
    }, { passive: true });
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
      }, { threshold: 0.3 }).observe(hero);
    }
    var startRotation = function () {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      window.setInterval(function () {
        if (hover || !inView || document.hidden || Date.now() < holdUntil) return;
        go(current + 1);
      }, 6000);
    };
    if (document.readyState === 'complete') startRotation();
    else window.addEventListener('load', startRotation);
  })();

  /* Autoprzewijanie karuzel opinii (01.09): co 6 s o jedną kartę, na końcu
     powrót na start. Pauza: hover, ręczna interakcja (12 s), karuzela poza
     ekranem, ukryta karta przeglądarki, prefers-reduced-motion. */
  /* Logo TrustMate w metryczce opinii: kopiujemy wbudowany SVG (data URI)
     z ukrytego widgetu w miejsce słowa „TrustMate" — zawsze aktualne. */
  window.cwOpLogo = function (root, sourceImg) {
    if (!sourceImg || !sourceImg.src) return;
    var link = root.querySelector('.cw-opinie__tm a');
    if (!link || link.querySelector('.cw-op__tmlogo')) return;
    var img = document.createElement('img');
    img.className = 'cw-op__tmlogo';
    img.alt = 'TrustMate';
    img.src = sourceImg.src;
    link.classList.add('cw-opinie__tm-link--logo');
    link.textContent = '';
    link.appendChild(img);
  };

  window.cwOpAutoplay = function (root, track) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var hover = false;
    var inView = true;
    var holdUntil = 0;
    var hold = function () { holdUntil = Date.now() + 12000; };
    track.addEventListener('pointerenter', function () { hover = true; });
    track.addEventListener('pointerleave', function () { hover = false; });
    track.addEventListener('touchstart', hold, { passive: true });
    track.addEventListener('wheel', hold, { passive: true });
    root.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('[data-cw-op-prev], [data-cw-op-next]')) hold();
    });
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
      }, { threshold: 0.3 }).observe(track);
    }
    window.setInterval(function () {
      if (hover || !inView || document.hidden || Date.now() < holdUntil) return;
      var card = track.querySelector('.cw-op__card');
      if (!card) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 48;
      var step = card.getBoundingClientRect().width + gap;
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) return;
      if (track.scrollLeft >= max - 8) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: step, behavior: 'smooth' });
    }, 6000);
  };

  /* ── Opinie TrustMate → własna karuzela (01.09) ──
     Widget renderuje się poza ekranem; zbieramy z niego karty i rysujemy
     własne w DNA. Fallback: klasa cw-op-fallback pokazuje oryginalny widget. */
  (function () {
    var root = document.querySelector('[data-cw-op]');
    if (!root) return;
    var source = root.querySelector('[data-cw-op-source]');
    var track = root.querySelector('[data-cw-op-track]');
    var meta = root.querySelector('[data-cw-op-meta]');
    var navbox = root.querySelector('[data-cw-op-navbox]');
    if (!source || !track) return;
    var esc = function (s) {
      var d = document.createElement('div');
      d.textContent = s;
      return d.innerHTML;
    };
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      var cards = source.querySelectorAll('.tm-carousel__card');
      if (!cards.length) {
        if (tries > 48) {
          window.clearInterval(timer);
          root.classList.add('cw-op-fallback');
        }
        return;
      }
      window.clearInterval(timer);
      var badge = source.querySelector('.tm-icon__verified-badge--active');
      var badgeBg = badge ? getComputedStyle(badge).backgroundImage : 'none';
      var html = '';
      var used = 0;
      cards.forEach(function (c) {
        var row = c.querySelector('[data-tm-review-grade]');
        var grade = row ? parseInt(row.getAttribute('data-tm-review-grade'), 10) : 0;
        if (!grade || grade < 2) return; /* bez 1★ (decyzja Michała) */
        var name = ((c.querySelector('.tm-carousel__name') || {}).textContent || '').trim();
        var text = ((c.querySelector('.tm-carousel__text') || {}).textContent || '').trim();
        var when = ((c.querySelector('.tm-carousel__created-at') || {}).textContent || '').trim();
        var verified = !!c.querySelector('.tm-icon__verified-badge--active');
        if (!text) return;
        used += 1;
        html += '<article class="cw-op__card">'
          + '<span class="cw-op__stars" aria-label="' + grade + '/5"><span class="cw-op__stars-fill" style="width:' + grade * 20 + '%">★★★★★</span><span class="cw-op__stars-base" aria-hidden="true">★★★★★</span></span>'
          + '<div class="cw-op__who">'
          + '<span class="cw-op__name">' + esc(name) + '</span>'
          + (verified ? '<span class="cw-op__badge" style="background-image:' + badgeBg.replace(/"/g, '&quot;') + '" title="' + (cwStr.verified || 'zweryfikowano') + '"></span>' : '')
          + (when ? '<span class="cw-op__when">' + esc(when) + '</span>' : '')
          + '</div>'
          + '<p class="cw-op__text">' + esc(text) + '</p>'
          + '</article>';
      });
      if (!used) {
        root.classList.add('cw-op-fallback');
        return;
      }
      track.innerHTML = html;
      var gM = ((source.querySelector('.tm-grades__grade') || source.querySelector('.tm-grades') || {}).textContent || '').match(/\d+[.,]\d+|\d+/);
      var cntM = ((source.querySelector('.tm-grades__text') || {}).textContent || '').match(/\d+/);
      var gradeEl = root.querySelector('[data-cw-op-grade]');
      var countEl = root.querySelector('[data-cw-op-count]');
      if (gradeEl && gM) gradeEl.textContent = gM[0];
      if (countEl && cntM) countEl.textContent = cwReviewsCount(parseInt(cntM[0], 10));
      track.hidden = false;
      if (meta) meta.hidden = false;
      if (navbox) navbox.hidden = false;
      if (window.cwOpLogo) window.cwOpLogo(root, source.querySelector('.tm-logo--for-light img, [class*="logo"] img'));
      root.classList.add('cw-op-ready');
      if (window.cwOpAutoplay) window.cwOpAutoplay(root, track);
    }, 250);
    root.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-cw-op-prev], [data-cw-op-next]');
      if (!btn) return;
      var dir = btn.hasAttribute('data-cw-op-next') ? 1 : -1;
      var card = track.querySelector('.cw-op__card');
      var step = card ? card.getBoundingClientRect().width + 48 : 360;
      track.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
    });
  })();

  /* Filtry (30.08): płynne rozwijanie/zwijanie sekcji w drawerze.
     CSS ma grid-rows 0fr→1fr, ale details chowa treść NATYCHMIAST po
     zdjęciu [open] (zamykanie bez animacji), a otwieranie potrafiło
     odpalić się bez klatki startowej → skok. Sterujemy oboma kierunkami. */
  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('.mobile-facets__details > summary');
    if (!summary) return;
    var details = summary.parentElement;
    var sub = details.querySelector('.mobile-facets__submenu');
    if (!sub) return;
    event.preventDefault();
    event.stopPropagation();
    if (details.getAttribute('data-cw-anim')) return;
    details.setAttribute('data-cw-anim', '1');
    var finish = function (e) {
      if (e && e.propertyName && e.propertyName !== 'grid-template-rows') return;
      sub.removeEventListener('transitionend', finish);
      window.clearTimeout(fallback);
      if (details.getAttribute('data-cw-anim') === 'close') details.open = false;
      sub.style.gridTemplateRows = '';
      details.removeAttribute('data-cw-anim');
    };
    var fallback = window.setTimeout(finish, 420);
    sub.addEventListener('transitionend', finish);
    if (details.open) {
      details.setAttribute('data-cw-anim', 'close');
      sub.style.gridTemplateRows = '1fr';
      void sub.offsetHeight;
      sub.style.gridTemplateRows = '0fr';
    } else {
      details.open = true;
      sub.style.gridTemplateRows = '0fr';
      void sub.offsetHeight;
      sub.style.gridTemplateRows = '1fr';
    }
  }, true);

  /* Akordeony PDP: details nie animuje się natywnie — przejmujemy klik
     w summary i animujemy wysokość treści (padding też, żeby nie skakał).
     Bez Web Animations API (stare silniki) zostaje natywne otwieranie. */
  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('.product__accordion summary, .cw-faq__item > summary');
    if (!summary) return;
    var details = summary.parentElement;
    var content = details.querySelector('.accordion__content');
    if (!content || typeof content.animate !== 'function') return;
    event.preventDefault();
    var ease = 'cubic-bezier(0.33, 0, 0.2, 1)';
    var closed = { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 };
    if (content.getAnimations().length) return; // animacja w toku
    if (details.open) {
      var cs = getComputedStyle(content);
      var from = {
        height: content.offsetHeight + 'px',
        paddingTop: cs.paddingTop,
        paddingBottom: cs.paddingBottom,
        opacity: 1,
      };
      /* fill:forwards — bez tego po ostatniej klatce treść wracała na PEŁNĄ
         wysokość na 1 klatkę, zanim details.open=false ją schował (SKOK) */
      var closing = content.animate([from, closed], { duration: 280, easing: ease, fill: 'forwards' });
      closing.onfinish = function () {
        details.open = false;
        closing.cancel();
      };
    } else {
      details.open = true;
      var cs2 = getComputedStyle(content);
      var to = {
        height: content.offsetHeight + 'px',
        paddingTop: cs2.paddingTop,
        paddingBottom: cs2.paddingBottom,
        opacity: 1,
      };
      content.animate([closed, to], { duration: 280, easing: ease });
    }
  });

  /* Karty produktów: strzałki przeglądania zdjęć (27.08). DELEGACJA na
     document (karty renderują się też AJAX-em); podmieniamy src OBU <img>
     w .media (główny + hoverowy), żeby hover-effect nie cofał zdjęcia.
     Faza CAPTURE: Shopify (product-component / standard actions) łapie klik
     na karcie w bubblingu wcześniej niż document i NAWIGUJE do produktu —
     capture pozwala nam go uprzedzić i uciąć propagację */
  /* 30.08: „czucie" strzałek na dotyku — CSS-owy ::before nie wystarczał
     (iOS koryguje tapnięcia w stronę NAJWIĘKSZEGO celu = linku karty).
     Zamiast hit-testu: każdy tap w promieniu 34px od środka strzałki
     traktujemy jak jej naciśnięcie. Tylko hover:none — mysz jest precyzyjna. */
  var cwNearCardnav = function (event) {
    if (!window.matchMedia('(hover: none)').matches) return null;
    var t = event.changedTouches && event.changedTouches[0];
    var x = t ? t.clientX : event.clientX;
    var y = t ? t.clientY : event.clientY;
    if (typeof x !== 'number' || typeof y !== 'number') return null;
    var under = document.elementFromPoint(x, y);
    var card = under && under.closest && under.closest('.card-wrapper');
    if (!card) return null;
    var best = null;
    var bestD = 34;
    card.querySelectorAll('[data-cw-cardnav]').forEach(function (b) {
      var r = b.getBoundingClientRect();
      if (!r.width) return;
      var d = Math.hypot(x - (r.x + r.width / 2), y - (r.y + r.height / 2));
      if (d < bestD) {
        bestD = d;
        best = b;
      }
    });
    return best;
  };
  window.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-cw-cardnav]');
    if (!btn) btn = cwNearCardnav(event);
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    var card = btn.closest('.card__inner') || btn.closest('.card-wrapper');
    var mediaBox = card && card.querySelector('.card__media');
    var galEl = card && card.querySelector('[data-cw-gal]');
    if (!galEl) return;
    var urls = (galEl.getAttribute('data-cw-gal') || '').split('|').filter(Boolean);
    if (urls.length < 2) return;
    var idxAttr = mediaBox.getAttribute('data-cw-idx');
    var idx;
    if (idxAttr === null) {
      /* start: jesli hover pokazuje wlasnie DRUGIE zdjecie, wychodzimy od
         niego (bez tego pierwszy klik "zmienial" na to, co juz widac) */
      var second = mediaBox.querySelectorAll('.media img')[1];
      idx = second && parseFloat(getComputedStyle(second).opacity) > 0.5 ? 1 : 0;
    } else {
      idx = parseInt(idxAttr, 10);
    }
    idx += parseInt(btn.getAttribute('data-cw-cardnav'), 10);
    if (idx < 0) idx = urls.length - 1;
    if (idx > urls.length - 1) idx = 0;
    mediaBox.setAttribute('data-cw-idx', String(idx));
    /* hover-effect Dawna pokazuje DRUGIE zdjecie przy najechaniu — pierwszy
       klik strzalki wygladal na martwy (podmienial na to, co hover juz
       pokazywal). Uzycie strzalek wylacza hoverowa podmiane na tej karcie. */
    var media = mediaBox.querySelector('.media');
    if (media) media.classList.add('cw-gal-on');
    mediaBox.querySelectorAll('.media img').forEach(function (img) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = urls[idx];
    });
  }, true);
  /* Shopify nawiguje do produktu NIE z clicka, tylko ze zdarzen pointer/mouse
     (JS-owy click() w testach przechodzil, realna mysz nawigowala) — tniemy
     im propagacje na strzalkach we wszystkich fazach dotyku/myszy */
  ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchend', 'click'].forEach(function (type) {
    window.addEventListener(type, function (event) {
      var onBtn = event.target.closest && event.target.closest('[data-cw-cardnav]');
      if (onBtn || cwNearCardnav(event)) {
        if (type === 'click') event.preventDefault();
        event.stopPropagation();
      }
    }, true);
  });

  /* PDP desktop: pionowe kropki nawigacji galerii (27.08, wzór Oh Polly) —
     klik przewija do zdjęcia, scroll podświetla kropkę najbliższą środka
     kadru; fixed przy prawej krawędzi galerii, widoczne tylko nad nią */
  (function () {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    var wrapper = document.querySelector('.product--stacked .product__media-wrapper');
    if (!wrapper) return;
    var items = Array.prototype.slice.call(wrapper.querySelectorAll('.product__media-item'));
    if (items.length < 2) return;
    var dots = document.createElement('div');
    dots.className = 'cw-gdots';
    dots.hidden = true;
    items.forEach(function (item, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'cw-gdots__dot';
      d.setAttribute('aria-label', (cwStr.photoLabel || 'Zdjęcie [n]').replace('[n]', i + 1));
      d.addEventListener('click', function () {
        item.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      dots.appendChild(d);
    });
    document.body.appendChild(dots);
    var btns = dots.children;
    var place = function () {
      var r = wrapper.getBoundingClientRect();
      dots.style.left = r.right - dots.offsetWidth - 16 + 'px';
    };
    var update = function () {
      var r = wrapper.getBoundingClientRect();
      /* kropki (fixed, środek = 50% vh) muszą w CAŁOŚCI leżeć na galerii —
         inaczej wystają pod zdjęcie nad „Podobne produkty" */
      var half = (dots.offsetHeight || items.length * 14) / 2 + 12;
      var mid = window.innerHeight / 2;
      var visible = r.top < mid - half && r.bottom > mid + half;
      dots.hidden = !visible;
      if (!visible) return;
      place();
      var mid = window.innerHeight / 2;
      var best = 0;
      var bestDist = Infinity;
      items.forEach(function (item, i) {
        var ir = item.getBoundingClientRect();
        var dist = Math.abs((ir.top + ir.bottom) / 2 - mid);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      for (var i = 0; i < btns.length; i += 1) {
        btns[i].classList.toggle('is-active', i === best);
      }
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();

  /* Ramka przedsprzedaży appki STOQ (28.08): dopisujemy do niej link
     „Dowiedz się więcej przed zakupem" -> /pages/przedsprzedaz.
     Widget wstrzykiwany async przez appkę — poll + observer, idempotentnie */
  function cwPreorderOfferLink() {
    var option = document.querySelector('.restock-rocket-payment-option');
    if (!option || option.querySelector('.cw-preorder-more')) return !!option;
    var a = document.createElement('a');
    a.className = 'cw-preorder-more';
    a.href = cwUrl('/pages/przedsprzedaz');
    a.textContent = cwStr.preorderMore || 'Dowiedz się więcej przed zakupem';
    option.appendChild(a);
    return true;
  }
  (function () {
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (cwPreorderOfferLink() || tries > 40) window.clearInterval(timer);
    }, 500);
    var form = document.querySelector('.product-form');
    if (form && window.MutationObserver) {
      new MutationObserver(function () { cwPreorderOfferLink(); }).observe(form, { childList: true, subtree: true });
    }
  })();

  /* PDP mobile: pasek postępu karuzeli zdjęć (GSQ) — iOS Safari nie renderuje
     custom ::-webkit-scrollbar na touch overflow, więc pasek jest lustrem scrolla */
  function cwInitPdpGalleryBar() {
    document.querySelectorAll('.product__media-wrapper slider-component').forEach(function (sc) {
      var list = sc.querySelector('.product__media-list');
      if (!list || sc.querySelector('.cw-gallery-bar')) return;
      if (list.querySelectorAll('.product__media-item').length < 2) return;
      var bar = document.createElement('div');
      bar.className = 'cw-gallery-bar';
      bar.innerHTML = '<span class="cw-gallery-bar__fill"></span>';
      sc.appendChild(bar);
      var fill = bar.firstElementChild;
      var update = function () {
        var total = list.scrollWidth;
        var vis = list.clientWidth;
        var scrollable = total - vis > 1;
        bar.style.opacity = scrollable ? '' : '0';
        if (!scrollable) return;
        var frac = vis / total;
        fill.style.width = frac * 100 + '%';
        var x = (list.scrollLeft / (total - vis)) * (1 - frac) * bar.clientWidth;
        fill.style.transform = 'translateX(' + x + 'px)';
      };
      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
    });
  }
  cwInitPdpGalleryBar();
  document.addEventListener('shopify:section:load', cwInitPdpGalleryBar);

  /* ══ LISTA ŻYCZEŃ (03.09) ══
     localStorage cw:wl = tablica handle'ów (najnowsze na początku, limit 100).
     Serduszka: karty produktów, PDP przy ATC, serce z licznikiem w headerze.
     Strona /pages/lista-zyczen: karty dociągane przez Section Rendering API
     (identyczny wygląd co kolekcje); 404 = produkt usunięty -> wypada z listy. */
  var cwWlRead = function () {
    try {
      var l = JSON.parse(localStorage.getItem('cw:wl') || '[]');
      return Array.isArray(l) ? l : [];
    } catch (e) {
      return [];
    }
  };
  var cwWlWrite = function (list) {
    try { localStorage.setItem('cw:wl', JSON.stringify(list.slice(0, 100))); } catch (e) {}
    cwWlBadge();
  };
  var cwWlBadge = function () {
    var n = cwWlRead().length;
    document.querySelectorAll('[data-cw-wl-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  };
  var cwWlSync = function () {
    var list = cwWlRead();
    document.querySelectorAll('[data-cw-wl]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-cw-wl')) > -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-cw-wl]');
    if (!btn) return;
    /* karta jest jednym wielkim linkiem — serduszko nie może nawigować */
    event.preventDefault();
    event.stopPropagation();
    var handle = btn.getAttribute('data-cw-wl');
    var list = cwWlRead();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1);
    else list.unshift(handle);
    cwWlWrite(list);
    cwWlSync();
    if (i === -1) {
      btn.classList.remove('cw-wl-pop');
      void btn.offsetWidth;
      btn.classList.add('cw-wl-pop');
    }
    /* na stronie listy: odznaczenie = natychmiastowe zniknięcie karty */
    var gridEl = document.querySelector('[data-cw-wl-grid]');
    if (gridEl && i > -1) {
      var li = btn.closest('li');
      if (li) li.remove();
      if (!gridEl.querySelector('li')) {
        gridEl.hidden = true;
        var empty = document.querySelector('[data-cw-wl-empty]');
        if (empty) empty.hidden = false;
      }
    }
  }, true);
  /* facety/AJAX podmieniają karty — dosynchronizuj stan serduszek */
  if (window.MutationObserver) {
    var cwWlMoTimer = null;
    new MutationObserver(function () {
      window.clearTimeout(cwWlMoTimer);
      cwWlMoTimer = window.setTimeout(cwWlSync, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }
  cwWlBadge();
  cwWlSync();

  /* strona listy życzeń */
  (function () {
    var grid = document.querySelector('[data-cw-wl-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-cw-wl-empty]');
    var list = cwWlRead();
    if (!list.length) {
      if (empty) empty.hidden = false;
      return;
    }
    var alive = [];
    Promise.all(list.map(function (handle) {
      return fetch(cwUrl('/products/' + encodeURIComponent(handle) + '?sections=cw-wishlist-item'))
        .then(function (r) {
          if (!r.ok) return null;
          return r.json();
        })
        .then(function (sections) {
          var html = sections && sections['cw-wishlist-item'];
          if (!html) return null;
          alive.push(handle);
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('.shopify-section') || doc.body;
          var li = document.createElement('li');
          li.className = 'grid__item';
          li.innerHTML = inner.innerHTML;
          return { handle: handle, li: li };
        })
        .catch(function () { return null; });
    })).then(function (results) {
      var byHandle = {};
      results.filter(Boolean).forEach(function (r) { byHandle[r.handle] = r.li; });
      /* kolejność zapisu (najnowsze pierwsze) */
      list.forEach(function (handle) {
        if (byHandle[handle]) grid.appendChild(byHandle[handle]);
      });
      if (alive.length !== list.length) {
        cwWlWrite(list.filter(function (h) { return alive.indexOf(h) > -1; }));
      }
      if (grid.querySelector('li')) {
        grid.hidden = false;
        cwWlSync();
      } else if (empty) {
        empty.hidden = false;
      }
    });
  })();

  /* (pasek postępu pod karuzelami usunięty 22.08 na prośbę Michała) */

  /* (opis kolekcji: „Pokaż więcej" + clamp usunięte 30.08 — pełny tekst
     w wąskiej kolumnie, patrz cloudwear.css) */
})();

/* Cloudwear (17.09, wzór nudyess): modale wyboru języka i kraju/waluty
   (snippets/cw-locale-modals) + flagi emoji z ISO w triggerach. */
(function () {
  /* modale renderuje stopka, ale przodkowie (sekcje, sticky) tworzą
     stacking contexty — na mobile drawer przykrywał X modala. Przenosimy
     je na koniec <body>: fixed + z-index liczą się wtedy od roota.
     22.09: to samo dla backdropu mega — wewnątrz sticky-sekcji headera
     przykrywał (dim+blur) SAM header; w body z2 ląduje POD sekcją (z4),
     a nad stroną. Listener kliku przenosi się razem z elementem. */
  document.querySelectorAll('.cw-lmodal, .cw-mega__backdrop').forEach(function (m) {
    document.body.appendChild(m);
  });
  /* 22.09: przy ZAMYKANIU drawera Dawn zdejmuje stany za wcześnie, a biały
     panel wyjeżdża jeszcze ~400ms — wpadał w negatyw jako brązowy błysk.
     Sygnał startu zamykania = zniknięcie .menu-opening (lekcja 21.08);
     trzymamy blend-OFF klasą cw-drawer-closing przez czas animacji. */
  var mdc = document.querySelector('.menu-drawer-container');
  if (mdc) {
    new MutationObserver(function () {
      if (!mdc.classList.contains('menu-opening')) {
        document.body.classList.add('cw-drawer-closing');
        clearTimeout(mdc._cwT);
        mdc._cwT = setTimeout(function () {
          document.body.classList.remove('cw-drawer-closing');
        }, 600);
      }
    }).observe(mdc, { attributes: true, attributeFilter: ['class'] });
  }
  var lmOpen = function (which) {
    var m = document.getElementById('CwLmodal-' + which);
    if (!m) return;
    m.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { m.classList.add('is-open'); });
    });
  };
  var lmCloseAll = function () {
    document.querySelectorAll('.cw-lmodal').forEach(function (m) {
      if (m.hidden) return;
      m.classList.remove('is-open');
      setTimeout(function () { m.hidden = true; }, 250);
    });
  };
  document.addEventListener('click', function (e) {
    var trg = e.target.closest('[data-cw-lmodal-open]');
    if (trg) {
      /* triggery to <a href="#"> (patrz cw-locale-triggers) — bez skoku strony */
      e.preventDefault();
      lmOpen(trg.getAttribute('data-cw-lmodal-open'));
      return;
    }
    if (e.target.closest('[data-cw-lmodal-close]')) lmCloseAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') lmCloseAll();
  });
  /* drawer mobile ma zostać OTWARTY pod modalem (życzenie Michała, wzór
     nudyess): Dawnowy MenuDrawer.onFocusOut zamyka menu, gdy focus wyjdzie
     poza drawer — a modal jest w stopce. Capture na menu-drawer odpala się
     przed Dawnowym bubble-listenerem: przy otwartym modalu ubijamy event. */
  var lmDrawer = document.querySelector('header-drawer');
  if (lmDrawer) {
    lmDrawer.addEventListener('focusout', function (e) {
      if (document.querySelector('.cw-lmodal:not([hidden])')) e.stopPropagation();
    }, true);
  }
  /* ISO → emoji flagi (PL → 🇵🇱): regional indicator = 0x1F1E6 + (znak - A);
     Liquid nie umie tej konwersji, JS robi ją raz na starcie */
  document.querySelectorAll('[data-cw-flag]').forEach(function (el) {
    var iso = (el.getAttribute('data-cw-flag') || '').toUpperCase();
    if (iso.length === 2) {
      el.textContent = String.fromCodePoint(127397 + iso.charCodeAt(0), 127397 + iso.charCodeAt(1));
    }
  });
})();

/* Cloudwear (22.09): popup newslettera (apka Shopify Forms) — nasz styl
   wstrzykiwany DO otwartego shadow rootu (style dokumentu tam nie
   sięgają; CSS custom properties TAK — stąd var(--font-heading-family)
   działa). Klasy Forms to CSS-modules z hashem (_formContainer_1q1d2_30)
   — selektory częściowe [class*="_x_"] są odporne na zmianę hasha. */
(function () {
  var CSS = [
    /* box: rogi proste, lekko WYDŁUŻONY poziomo (dyspozycja) */
    '[class*="_formContainer_"] { border-radius: 0 !important; font-family: var(--font-body-family, Inter, sans-serif); }',
    '@media screen and (min-width: 491px) { [class*="_formContainer_"] { width: 25rem; max-width: 25rem; } }',
    /* overlay pod spodem: dim + blur jak koszyk/mega */
    '[class*="_overlayBackground_"] { background: rgba(33, 33, 33, 0.45) !important; backdrop-filter: blur(6px); -webkit-backdrop-filter: blur(6px); }',
    /* typografia: nagłówek w foncie nagłówkowym motywu, -1px na całości */
    'h1, h2, h3 { font-family: var(--font-heading-family, Muli, sans-serif) !important; font-weight: 400 !important; font-size: 18px !important; line-height: 1.3 !important; letter-spacing: 0.04em; color: #212121 !important; }',
    'p, label, span { color: #212121; }',
    'p { font-size: 12px !important; line-height: 1.55 !important; }',
    /* disclaimer (ostatni akapit, drobny) */
    'form p:last-of-type, [class*="disclaimer"], small { font-size: 10px !important; color: #757575 !important; }',
    /* input: prosty, bez zaokrągleń; MOBILE 16px — iOS auto-zoomuje
       stronę przy focusie inputa z fontem <16px (zgłoszenie Michała)
       i zoom zostaje po zapisie — 16px wyłącza zoom u źródła */
    'input[type="email"], input[type="text"], input[type="tel"] { border-radius: 0 !important; border: 1px solid #212121 !important; font-size: 13px !important; box-shadow: none !important; }',
    '@media (max-width: 749px) { input[type="email"], input[type="text"], input[type="tel"] { font-size: 16px !important; } }',
    /* checkbox zgody (nasz — Forms nie ma natywnego) */
    '.cw-consent { display: flex; gap: 8px; align-items: flex-start; text-align: left; margin: 12px 0 2px; cursor: pointer; }',
    '.cw-consent input { width: 13px; height: 13px; margin: 1px 0 0; accent-color: #212121; flex: none; cursor: pointer; }',
    '.cw-consent span { font-size: 8px !important; line-height: 1.45; color: #757575 !important; }',
    '.cw-consent.cw-consent--error span { color: #a4000e !important; }',
    '.cw-consent.cw-consent--error input { outline: 1px solid #a4000e; outline-offset: 1px; }',
    /* przycisk: nasze CTA — grafit, rogi proste, wersaliki z trackingiem */
    'button[type="submit"] { background: #212121 !important; color: #ffffff !important; border: none !important; border-radius: 0 !important; font-size: 11px !important; font-weight: 500 !important; letter-spacing: 0.12em !important; text-transform: uppercase !important; padding: 1.2rem 1.6rem !important; }',
    'button[type="submit"]:hover { background: #000000 !important; }',
  ].join('\n');
  var inject = function (host) {
    var sr = host.shadowRoot;
    if (!sr) return;
    if (!host._cwStyled) {
      host._cwStyled = true;
      try {
        var sheet = new CSSStyleSheet();
        sheet.replaceSync(CSS);
        sr.adoptedStyleSheets = sr.adoptedStyleSheets.concat(sheet);
      } catch (e) {
        var st = document.createElement('style');
        st.textContent = CSS;
        sr.appendChild(st);
      }
      /* wymagany checkbox: blokuj submit póki niezaznaczony (capture
         łapie klik przed Reactem apki) */
      sr.addEventListener('click', function (ev) {
        var btn = ev.target && ev.target.closest && ev.target.closest('button[type="submit"]');
        if (!btn) return;
        var box = sr.querySelector('.cw-consent input');
        if (box && !box.checked) {
          ev.preventDefault();
          ev.stopPropagation();
          var lab = sr.querySelector('.cw-consent');
          lab.classList.add('cw-consent--error');
          box.addEventListener('change', function () {
            lab.classList.remove('cw-consent--error');
          }, { once: true });
        }
      }, true);
      /* zamknięcie krzyżykiem lub klikiem w tło → zapamiętaj na dłużej */
      sr.addEventListener('click', function (ev) {
        var t = ev.target;
        if (!t || !t.closest) return;
        if (t.closest('[class*="_formCloseButton_"]') ||
            (!t.closest('[class*="_formContainer_"]') && t.closest('[class*="_overlay"]'))) {
          rememberClose(host);
        }
      }, true);
      /* struktura zmienia się (kroki formularza) — pilnuj checkboxa */
      new MutationObserver(function () { ensureConsent(sr); }).observe(sr, { childList: true, subtree: true });
    }
    ensureConsent(sr);
  };
  /* 30.09: Forms pamięta zamknięcie tylko do końca SWOJEJ sesji (30 min
     bez aktywności, klucz <id>-dismissed-in-session) — przy kolejnej
     wizycie popup wracał. Trwale ukrywa go tylko klucz po zapisie
     (<id>-dismissed-after-submit = id formularza), więc po zamknięciu
     ustawiamy go sami, z własnym znacznikiem czasu: po CW_POPUP_DAYS
     dniach zdejmujemy go i popup pokaże się raz jeszcze. Prawdziwy
     zapis (klucz ustawiony przez Forms, bez naszego znacznika) zostaje
     na zawsze. */
  var CW_POPUP_DAYS = 14;
  var formIdOf = function (host) {
    var m = (host.id || '').match(/(\d+)$/);
    return m ? m[1] : null;
  };
  var rememberClose = function (host) {
    var id = formIdOf(host);
    if (!id) return;
    try {
      if (localStorage.getItem(id + '-dismissed-after-submit') === id) return;
      localStorage.setItem(id + '-dismissed-after-submit', id);
      localStorage.setItem('cw:popup-closed:' + id, String(Date.now()));
    } catch (e) {}
  };
  try {
    Object.keys(localStorage).forEach(function (k) {
      if (k.indexOf('cw:popup-closed:') !== 0) return;
      var at = Number(localStorage.getItem(k));
      if (at && Date.now() - at < CW_POPUP_DAYS * 864e5) return;
      localStorage.removeItem(k.slice('cw:popup-closed:'.length) + '-dismissed-after-submit');
      localStorage.removeItem(k);
    });
  } catch (e) {}
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    document.querySelectorAll('shopify-forms-embed').forEach(function (host) {
      var box = host.shadowRoot && host.shadowRoot.querySelector('[class*="_formContainer_"]');
      if (box && box.getBoundingClientRect().width > 0) rememberClose(host);
    });
  }, true);
  var ensureConsent = function (sr) {
    var btn = sr.querySelector('button[type="submit"]');
    if (!btn || sr.querySelector('.cw-consent')) return;
    /* schowaj oryginalny akapit-disclaimer (PL i EN — Forms tłumaczy
       treść formularza, zgłoszenie Michała 22.09) */
    sr.querySelectorAll('p').forEach(function (par) {
      if (/Klikając|By clicking/.test(par.textContent)) par.style.display = 'none';
    });
    var en = (document.documentElement.lang || '').indexOf('en') === 0;
    var txt = en
      ? 'I accept the terms and conditions and consent to the processing of my personal data in order to receive the newsletter.'
      : 'Akceptuję regulamin i wyrażam zgodę na przetwarzanie danych osobowych w celu otrzymywania newslettera.';
    var lab = document.createElement('label');
    lab.className = 'cw-consent';
    lab.innerHTML = '<input type="checkbox"><span></span>';
    lab.querySelector('span').textContent = txt;
    btn.parentNode.insertBefore(lab, btn);
  };
  var scan = function () {
    document.querySelectorAll('shopify-forms-embed').forEach(inject);
  };
  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
